export const REVIEW = {
    AAA_IDENTIFIER: "Review-d-ReviewAaaIdentifier",
    ANVIL_ID: "Review-d-ReviewAnvilId",
    ANVIL_TASK_ID: "Review-d-ReviewAnvilTaskID",
    OWNER: "Review-d-ReviewOwner",
    NO_EXTERNAL_ID_EXPLANATION: "Review-d-ReviewNoExternalIDExplanation",
    RELATED_BINDLES: "Review-d-ReviewRelatedBindles",
};
